import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { GET_TIME_ZONE2 } from "../../Models/contactModel";
function ContactTable({
  contactRecs,
  contactRecss_Get_Req,
  setFormOpener,
  TableFilter,
  setPartnerForm,
  PartnerForm,
}) {
  const [CoursesPage_data, setCoursesPage_data] = useState(contactRecs);
  const { total } = useSelector((state) => state.listContactReducer);

  let records = Math.ceil(total && total / TableFilter.PageSize);
  const arr = Array.from({ length: records }, (_, index) => index + 1);
  const { userDet } = useSelector((s) => s.LoginReducer);
  const handlePage = async (page) => {
    await contactRecss_Get_Req({
      ...TableFilter,
      PageNo: TableFilter.PageNo + page,
    });
  };
  const Total_Records = total && total;

  const handleSinglePage = (page) => {
    contactRecss_Get_Req({ ...TableFilter, PageNo: page });
  };
  const handleTablePageCount = (e) => {
    contactRecss_Get_Req({ ...TableFilter, PageSize: +e.target.value });
  };

  const Users = [3, 2,99];

  useEffect(() => {
    setCoursesPage_data(contactRecs);
  }, [contactRecs]);

  return (
    <div className="col-md-9 col-lg-10">
      <div className="coctacts-table">
        <div className="table-responsive custom-scroll-right-bottum">
          <table className="table table-condensed ">
            <thead className="t-head-th-bg">
              <tr>
                <th className="t-head-fixed">Contact Name</th>
                <th className="t-head-fixed">Email Address</th>
                <th className="t-head-fixed">Phone No</th>
                <th className="t-head-fixed">Contact Owner</th>
                <th className="t-head-fixed">Create Date</th>
                {/* <th className="t-head-fixed">Preferred Destination</th>
                <th className="t-head-fixed">Course</th> */}
                {userDet && Users.includes(userDet[0]?.Users_Id) ? (
                  <th className="t-head-fixed">Send</th>
                ) : (
                  ""
                )}
              </tr>
            </thead>
            <tbody className="table-bordered">
              {contactRecs?.map((el, i) => (
                <tr key={el.Contact_Id}>
                  <td key={i}>
                    <Link
                      style={{ color: "blue" }}
                      to={`https://thesearcheducation.com/Contacts/Edit/${el.Contact_Id}`}
                      target="_blank"
                    >
                      {" "}
                      {el?.full_name
                        ? el?.full_name
                        : el?.First_Name + " " + el?.Last_Name}
                    </Link>
                  </td>
                  <td>
                    {" "}
                    <Link
                      style={{ color: "blue" }}
                      to={`https://thesearcheducation.com/Contacts/Edit/${el.Contact_Id}`}
                      target="_blank"
                    >
                      {el?.Email_Address}{" "}
                    </Link>
                  </td>
                  <td>
                    {" "}
                    <Link
                      style={{ color: "blue" }}
                      to={`https://thesearcheducation.com/Contacts/Edit/${el.Contact_Id}`}
                      target="_blank"
                    >
                      {el?.Phone_No}
                    </Link>
                  </td>
                  <td>{el?.ContactOwner_Name || "--"}</td>
                  <td>
                    {el?.Last_Created_Date
                      ? GET_TIME_ZONE2(el?.Last_Created_Date)
                      : ""}
                  </td>
                  {/* <td></td>
                  <td></td> */}
                  {userDet && Users.includes(userDet[0]?.Users_Id) ? (
                    <td style={{ width: "250px" }}>
                      {el?.Partner_Id ? (
                        "Already Sent"
                      ) : (
                        <button
                          className="cst_btn"
                          onClick={() => {
                            setPartnerForm({
                              ...PartnerForm,
                              Contact_Id: el?.Contact_Id,
                              name: el?.full_name
                                ? el?.full_name
                                : el?.First_Name + " " + el?.Last_Name,
                              email: el?.Email_Address,
                              mobile_number: el?.Phone_No,
                              target_country_code: "",
                              amount: "",
                              note: "",
                            });
                            setFormOpener(true);
                          }}
                        >
                          Send to Partner
                        </button>
                      )}
                    </td>
                  ) : (
                    ""
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="Pagination">
          <div className="table-page-details">
            <div className="row">
              <div className="col-md-9">
                <div className="page-number">
                  <ul className="pagination justify-content-center">
                    <li className="page-item">
                      <button
                        onClick={() => handlePage(-1)}
                        disabled={+TableFilter.PageNo === 1}
                        className={
                          TableFilter.PageNo === 1
                            ? "page-link deactive"
                            : "page-link button_color"
                        }
                      >
                        Previous
                      </button>
                    </li>
                    {arr?.map((el, i) => (
                      <li
                        onClick={() => handleSinglePage(+el)}
                        key={i}
                        className={
                          i <= TableFilter.PageNo + 4 &&
                          i >= TableFilter.PageNo - 3
                            ? "page-item"
                            : "page-item2"
                        }
                      >
                        <a
                          className={
                            i === TableFilter.PageNo - 1
                              ? "active_button page-link"
                              : "page-link"
                          }
                        >
                          {el}
                        </a>
                      </li>
                    ))}
                    <li className="page-item">
                      <button
                        onClick={() => {
                          handlePage(1);
                        }}
                        disabled={
                          TableFilter.PageNo ===
                          Math.ceil(Total_Records / TableFilter.PageSize)
                        }
                        className={
                          TableFilter.PageNo ===
                          Math.ceil(Total_Records / TableFilter.PageSize)
                            ? "page-link deactive"
                            : "page-link button_color"
                        }
                        href="#"
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-3 text-center">
                <div className="page-counter">
                  <label>
                    <select
                      value={TableFilter.PageSize}
                      onChange={(e) => {
                        handleTablePageCount(e);
                      }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>{" "}
                    of <span>{total ? total : 0}</span> records
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactTable;
